import Vue from "vue";
import { addClass, removeClass } from "../utils";
import { Message } from "element-ui";
Vue.directive("checkParams", {
  inserted: function(ele, validateStr) {
    // 将验证规则拆分为验证数组
    let validateRuleArr = validateStr.value.split("|");
    // 监听失去焦点的时候
    // let el = ele.children[0];
    let el = ele.querySelector(".el-input__inner");
    // console.log(el.placeholder,validateStr,'需要验证的字段')
    if (ele.className.indexOf("el-select") != "-1") {
      // console.log('000')
      // console.log(el.value)
      el.addEventListener("input", function() {
        // console.log('blur')
        //失去焦点进行验证
        checkedfun(true);
      });
    } else {
      el.addEventListener("blur", function() {
        //失去焦点进行验证
        checkedfun();
      });
    }

    // 循环进行验证
    function checkedfun(flag) {
      for (var i = 0; i < validateRuleArr.length; ++i) {
        let requiredRegex = /^required$/; // 判断设置了required
        let carNoRegex = /^carNo$/; //判断设置了carNo
        let emailRegex = /^email$/; // 判断设置了email
        let phoneRegex = /^phone$/; // 判断设置了 phone
        let idCardRegex = /^idCard$/; // 判断设置了 idCard身份证号
        let minRegex = /min\(/; //判断设置了min 最小值
        let maxRegex = /max\(/; //判断设置了max 最大值
        let minlengthRegex = /minlength\(/; //判断设置了 minlength 最大长度
        let maxlengthRegex = /maxlength\(/; //判断设置了 maxlength 最大长度
        let regexRegex = /regex\(/;
        // 判断设置了required
        if (requiredRegex.test(validateRuleArr[i])) {
          // console.log(el);
          if (!required(flag)) {
            break;
          } else {
            removeTips();
          }
        }

        // 判断设置了车牌
        if (carNoRegex.test(validateRuleArr[i])) {
          if (!carNo()) {
            break;
          } else {
            removeTips();
          }
        }

        // 判断设置了email
        if (emailRegex.test(validateRuleArr[i])) {
          if (!email()) {
            break;
          } else {
            removeTips();
          }
        }

        // 判断设置了 phone
        if (phoneRegex.test(validateRuleArr[i])) {
          if (!phone()) {
            break;
          } else {
            removeTips();
          }
        }
        // 判断设置了 idCard
        if (idCardRegex.test(validateRuleArr[i])) {
          if (!idCard()) {
            break;
          } else {
            removeTips();
          }
        }

        // 判断是否设置了最小值
        if (minRegex.test(validateRuleArr[i])) {
          if (!eval(validateRuleArr[i])) {
            break;
          } else {
            removeTips();
          }
        }

        // 判断是否设置了最大值
        if (maxRegex.test(validateRuleArr[i])) {
          if (!eval(validateRuleArr[i])) {
            break;
          } else {
            removeTips();
          }
        }

        // 判断设置了最小长度
        if (minlengthRegex.test(validateRuleArr[i])) {
          if (!eval(validateRuleArr[i])) {
            break;
          } else {
            removeTips();
          }
        }

        // 判断设置了最大长度
        if (maxlengthRegex.test(validateRuleArr[i])) {
          if (!eval(validateRuleArr[i])) {
            break;
          } else {
            removeTips();
          }
        }

        // 判断测试正则表达式
        if (regexRegex.test(validateRuleArr[i])) {
          if (!eval(validateRuleArr[i])) {
            break;
          } else {
            removeTips();
          }
        }
      }
    }

    // 验证是否是必填项
    function required(flag) {
      // console.log(el.value);
      // if(flag){
      //   setTimeout(()=>{

      //   },900)
      // }
      if (el.value == "" || el.value == null) {
        tipMsg("请输入必填项" + el.placeholder);
        return false;
      }
      return true;
    }

    // 验证是否是车牌
    function carNo() {
      let carNoRule = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/;
      if (el.value && !carNoRule.test(el.value)) {
        tipMsg("请输入正确的车牌号");
        return false;
      }

      return true;
    }

    // 验证是否是邮箱
    function email() {
      let emailRule = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      if (el.value && !emailRule.test(el.value)) {
        tipMsg("请输入正确的邮箱地址");
        return false;
      }

      return true;
    }

    // 验证是否是手机号码
    function phone() {
      let phoneRule = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (el.value && !phoneRule.test(el.value)) {
        tipMsg("请输入正确的手机号码");
        return false;
      }

      return true;
    }
    // 判断是否是身份证号
    function idCard() {
      let idCardRule = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X)$)/;
      if (el.value && !idCardRule.test(el.value)) {
        tipMsg("请输入正确的身份证");
        return false;
      }

      return true;
    }
    // 最小值验证
    function min(num) {
      if (el.value && el.value < num) {
        tipMsg("最小值不能小于" + num);
        //console.log('最小值不能小于'+num);
        return false;
      }

      return true;
    }

    // 最大值验证
    function max(num) {
      if (el.value && el.value > num) {
        tipMsg("最大值不能大于" + num);
        //console.log('最大值不能大于'+num);
        return false;
      }

      return true;
    }

    // 最小长度验证
    function minlength(length) {
      if (el.value && el.value.length < length) {
        //console.log('最小长度不能小于'+length);
        tipMsg("最小长度不能小于" + length);
        return false;
      }

      return true;
    }

    // 最大长度进行验证
    function maxlength(length) {
      if (el.value && el.value.length > length) {
        //console.log('最大长度不能大于'+length);
        tipMsg("最大长度不能大于" + length);
        return false;
      }
      return true;
    }

    // 进行正则表达式的验证
    function regex(rules) {
      if (el.value && !rules.test(el.value)) {
        tipMsg("请输入正确的格式");
        return false;
      }
      return true;
    }

    // 添加提示信息
    function tipMsg(msg) {
      addClass(el, "input-error");
      Message({
        message: msg,
        customClass: "custom-message",
        offset: "110",
        type: "warning",
        center: true
      });
    }

    // 移除提示信息
    function removeTips() {
      removeClass(el, "input-error");
    }
  }
});

Vue.directive("checkSubmit", {
  inserted: function(el, binding, vNode) {
    el.addEventListener("click", function(event) {
      let elements = document.getElementsByClassName("v-check");
      var evObj = document.createEvent("Event");
      evObj.initEvent("blur", true, true);
      for (let element of elements) {
        // let el = element.children[1].children[0].children[0];
        let el = element.querySelector(".el-input__inner");
        // console.log(el);
        el && el.dispatchEvent(evObj);
      }
      let errorInputs = document.getElementsByClassName("input-error");
      if (errorInputs.length === 0) {
        vNode.context.checkSubmit(true, vNode.elm.dataset.eventkey);
      } else {
        vNode.context.checkSubmit(false, vNode.elm.dataset.eventkey);
      }
    });
  }
});



// WEBPACK FOOTER //
// ./src/directives/validate.js